<template>
  <div class="main-layout">
    <header-component class="layout__header" ref="header" :currentLang="currentLang" />
    <main class="layout__main">
      <slot></slot>
    </main>
    <footer-component class="layout__footer" :currentLang="currentLang" :contactTxt="contactTxt" :contactMobileTxt="contactMobileTxt" />
  </div>
</template>

<script>
import HeaderComponent from './Header.vue';
import FooterComponent from './Footer.vue';

export default {
  name: 'MainLayout',
  props: {
    currentLang: {
      type: String,
      default: 'en',
    },
    // contact us
    contactTxt: {
      type: String,
      default: '联系我们，开启您的全球化营销数智加速之旅！',
    },
    contactMobileTxt: {
      type: String,
      default: '',
    }
  },
  components: {
    HeaderComponent,
    FooterComponent,
  },
  watch: {
    // 监听,当路由发生变化的时候执行
    $route: {
      // $route可以用引号，也可以不用引号
      handler(to, from) {
        this.$nextTick(() => {
          if(to.path == '/supportTools' || to.path == '/developTools') {
            this.$refs.header.changeFirstNavIndex(0);
          } else if(to.path == '/about') {
            this.$refs.header.changeFirstNavIndex(1);
          } else if(to.path == '/contact') {
            this.$refs.header.changeFirstNavIndex(2);
          } else {
            this.$refs.header.changeFirstNavIndex(-1);
          }
        })
      },
      deep: true, // 深度观察监听
      immediate: true, // 第一次初始化渲染就可以监听到
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.main-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

main {
  flex: 1;
  margin-top: 60px;
}
</style>
